import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SignUpScreen } from '@/features/auth/routes/sign-up-screen'

export const Route = createFileRoute('/sign-up')({
  // Older links carry where to go afterwards; confirming the email now always
  // opens the app (or the waiting page), so it is accepted and not needed.
  validateSearch: z.object({ redirect: z.string().optional() }),
  component: SignUpScreen,
})
